<h1 mat-dialog-title>
  @if (availabilityType() === 'vehicles') {
    Ingeroosterd voor {{ itemName() }}
  } @else if (availabilityType() === 'availability') {
    Ingeroosterd voor {{ itemName() }}
  } @else if (availabilityType() === 'exceptions') {
    Ingeroosterd binnen deze periode
  } @else {
    Let op!
  }
</h1>
<mat-dialog-content class="mat-typography">
  @if (availabilityType() === 'availability') {
    <p>
      Let op: je bent momenteel ingepland voor toekomstige ritten in dit dagdeel. Weet je zeker dat je jouw
      beschikbaarheid voor dit dagdeel wilt wijzigen? Een planner zal voor dit dagdeel het rooster opnieuw moeten
      inplannen.
    </p>
  }
  @if (availabilityType() === 'vehicles') {
    <p>
      Let op: je bent momenteel ingepland voor toekomstige ritten met dit voertuig. Weet je zeker dat je jouw
      beschikbaarheid voor dit voertuig wilt wijzigen? Een planner zal voor dit voertuig het rooster opnieuw moeten
      inplannen.
    </p>
  }
  @if (availabilityType() === 'exceptions') {
    <p>
      Let op: je bent momenteel ingepland voor toekomstige ritten binnen de periode van deze uitzondering. Weet je zeker
      dat je deze uitzondering wilt toevoegen? Een planner zal voor deze periode het rooster opnieuw moeten inplannen.
    </p>
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button autofocus mat-button class="error-color" [mat-dialog-close]="true" cdkFocusInitial>Ja, toch wijzigen</button>
  <button mat-flat-button mat-dialog-close>Nee, niet wijzigen</button>
</mat-dialog-actions>
